import { useEffect, useState } from "react"
import { useAuthContext } from "../../contexts/AuthContext"
import { useNotificacionesContext } from "../../contexts/NotificacionesContext"

const NotificacionesUpdater = () => {

    const [etc, setEtc] = useState(0)
    const { token } = useAuthContext()
    const { indexNotificacionesHook } = useNotificacionesContext()

    useEffect(() => {
        if(token){
            indexNotificacionesHook()
            setTimeout(() => {
                setEtc(etc + 0.000001)
            }, 30000)
        }
        // eslint-disable-next-line
    },[token, etc])

    return null
}

export { NotificacionesUpdater }
